/**
 * 연도 선택 옵션을 내림차순(최신 연도 우선)으로 정렬
 */
export function sortYearOptionsDesc<T extends { value: string }>(options: T[]): T[] {
  return [...options].sort(
    (a, b) => parseInt(String(b.value), 10) - parseInt(String(a.value), 10),
  );
}
